import { jsx as C } from "react/jsx-runtime";
const e = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 13 7",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M6.50367 2.11387L11.4196 6.74712C11.5056 6.82846 11.6078 6.89301 11.7204 6.93705C11.8329 6.9811 11.9536 7.00377 12.0755 7.00377C12.1974 7.00377 12.3181 6.9811 12.4307 6.93705C12.5432 6.89301 12.6455 6.82846 12.7315 6.74712C12.9051 6.58195 13.0024 6.35894 13.0024 6.12655C13.0024 5.89416 12.9051 5.67115 12.7315 5.50598L7.16163 0.255028C6.99259 0.0962724 6.76507 0.00500063 6.52639 0.000199447C6.28772 -0.00460174 6.05626 0.0774369 5.88018 0.22925L0.273848 5.50312C0.187311 5.58424 0.118587 5.68061 0.0716002 5.78674C0.0246137 5.89287 0.000284908 6.00668 2.48746e-06 6.12166C-0.000279934 6.23664 0.0234895 6.35056 0.0699542 6.45689C0.116419 6.56322 0.184669 6.6599 0.270807 6.74139C0.356945 6.82288 0.459284 6.8876 0.571982 6.93185C0.68468 6.9761 0.805529 6.99901 0.927629 6.99928C1.04973 6.99954 1.17069 6.97716 1.2836 6.9334C1.39652 6.88964 1.49917 6.82537 1.58571 6.74425L6.50367 2.11387Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as Content
};
